/* eslint-disable no-loss-of-precision */
import blank from '../../Blank/blankData'

import CheekL from '../../FacialLines/CheekL'
import CheekRound from '../../FacialLines/CheekRound'
import CheekSquare from '../../FacialLines/CheekSquare'
import Cheeks from '../../FacialLines/Cheeks'
import MouthDimple from '../../FacialLines/MouthDimple'
import Chin from '../../FacialLines/Chin'

const data = [
  blank,
  {
    id: 'Chin',
    svg: Chin,
    positioning: {
      pointNarrow: {
        y: 117.62469482421875,
        scaleX: 0.85,
      },
      pointMedium: {
        y: 115.57080078125,
        scaleX: 0.9,
      },
      pointWide: {
        y: 115.91285705566406,
        scaleX: 1,
      },
      roundNarrow: {
        y: 117.28233337402344,
        scaleX: 0.85,
      },
      roundMedium: {
        y: 120.54446411132812,
        scaleX: 0.9,
      },
      roundWide: {
        y: 118.29924011230469,
        scaleX: 1,
      },
      squareNarrow: {
        y: 118.33619689941406,
        scaleX: 0.85,
      },
      squareMedium: {
        y: 117.98762512207031,
        scaleX: 1,
      },
      squareWide: {
        y: 118.44166564941406,
        scaleX: 1,
      },
    },
  },
  {
    id: 'CheekL',
    svg: CheekL,
    positioning: {
      pointNarrow: {
        y: 119.73954772949219,
        scaleX: 0.9,
      },
      pointMedium: {
        y: 120.3038330078125,
        scaleX: 1,
      },
      pointWide: {
        y: 118.72125244140625,
        scaleX: 1,
      },
      roundNarrow: {
        y: 121.18603515625,
        scaleX: 0.95,
      },
      roundMedium: {
        y: 120.84757995605469,
        scaleX: 0.9,
      },
      roundWide: {
        y: 121.18110656738281,
        scaleX: 1,
      },
      squareNarrow: {
        y: 118.58804321289062,
        scaleX: 0.9,
      },
      squareMedium: {
        y: 121.15838623046875,
        scaleX: 1,
      },
      squareWide: {
        y: 122.38665771484375,
        scaleX: 1,
      },
    },
  },

  {
    id: 'CheekRound',
    svg: CheekRound,
    positioning: {
      pointNarrow: {
        y: 123.209716796875,
        scaleX: 1,
      },
      pointMedium: {
        y: 121.81782531738281,
        scaleX: 1,
      },
      pointWide: {
        y: 115.90081787109375,
        scaleX: 1,
      },
      roundNarrow: {
        y: 124.38099670410156,
        scaleX: 1,
      },
      roundMedium: {
        y: 123.71028137207031,
        scaleX: 1,
      },
      roundWide: {
        y: 124.18576049804688,
        scaleX: 1,
      },
      squareNarrow: {
        y: 120.91925048828125,
        scaleX: 1,
      },
      squareMedium: {
        y: 123.15715026855469,
        scaleX: 1,
      },
      squareWide: {
        y: 123.95278930664062,
        scaleX: 1,
      },
    },
  },

  {
    id: 'CheekSquare',
    svg: CheekSquare,
    positioning: {
      pointNarrow: {
        y: 119.26480102539062,
        scaleX: 0.95,
      },
      pointMedium: {
        y: 120.29360961914062,
        scaleX: 1,
      },
      pointWide: {
        y: 119.17112731933594,
        scaleX: 1.05,
      },
      roundNarrow: {
        y: 118.95254516601562,
        scaleX: 1,
      },
      roundMedium: {
        y: 120.82804870605469,
        scaleX: 1,
      },
      roundWide: {
        y: 122.91891479492188,
        scaleX: 1,
      },
      squareNarrow: {
        y: 119.37942504882812,
        scaleX: 0.95,
      },
      squareMedium: {
        y: 122.00340270996094,
        scaleX: 1,
      },
      squareWide: {
        y: 122.22671508789062,
        scaleX: 1,
      },
    },
  },

  {
    id: 'Cheeks',
    svg: Cheeks,
    positioning: {
      pointNarrow: {
        y: 111.57382202148438,
        scaleX: 0.8,
      },
      pointMedium: {
        y: 114.30393981933594,
        scaleX: 0.9,
      },
      pointWide: {
        y: 110.41909790039062,
        scaleX: 1.1,
      },
      roundNarrow: {
        y: 114.16372680664062,
        scaleX: 0.8,
      },
      roundMedium: {
        y: 114.40562438964844,
        scaleX: 1,
      },
      roundWide: {
        y: 112.61598205566406,
        scaleX: 1,
      },
      squareNarrow: {
        y: 112.12841796875,
        scaleX: 0.8,
      },
      squareMedium: {
        y: 112.90975952148438,
        scaleX: 1,
      },
      squareWide: {
        y: 112.22648620605469,
        scaleX: 1,
      },
    },
  },
  {
    id: 'MouthDimple',
    svg: MouthDimple,
    positioning: {
      pointNarrow: {
        y: 123.38911437988281,
        scaleX: 1,
      },
      pointMedium: {
        y: 124.5955810546875,
        scaleX: 1,
      },
      pointWide: {
        y: 122.93417358398438,
        scaleX: 1,
      },
      roundNarrow: {
        y: 123.78776550292969,
        scaleX: 1,
      },
      roundMedium: {
        y: 123.30552673339844,
        scaleX: 1,
      },
      roundWide: {
        y: 124.36360168457031,
        scaleX: 1,
      },
      squareNarrow: {
        y: 121.65077209472656,
        scaleX: 1,
      },
      squareMedium: {
        y: 123.195556640625,
        scaleX: 1,
      },
      squareWide: {
        y: 123.82627868652344,
        scaleX: 1,
      },
    },
  },
]

export default data
